import React, { useEffect, useState } from 'react';
import { QuestionReport } from '../../types';
import { fetchReports, updateReportStatus } from '../../services/dataService';

const AdminReports: React.FC = () => {
    const [reports, setReports] = useState<QuestionReport[]>([]);

    useEffect(() => {
        const loadReports = async () => {
            const data = await fetchReports();
            setReports(data);
        };
        loadReports();
    }, []);

    const handleResolveReport = async (id: string, status: 'resolved' | 'dismissed') => {
        await updateReportStatus(id, status);
        setReports(prev => prev.map(r => r.id === id ? { ...r, status } : r));
    };

    return (
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
            <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex justify-between items-center">
                <h3 className="font-bold text-slate-800 dark:text-white">Question Reports</h3>
                <span className="text-sm bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 px-2 py-1 rounded text-slate-500 dark:text-slate-400">{reports.length} total</span>
            </div>

            {reports.length === 0 ? (
                <div className="p-12 text-center text-slate-500 dark:text-slate-400">
                    <div className="w-16 h-16 bg-slate-100 dark:bg-slate-900 rounded-full flex items-center justify-center mx-auto mb-4 text-slate-400 dark:text-slate-500 text-2xl">
                        <i className="fas fa-check-circle"></i>
                    </div>
                    <p className="text-lg font-medium">All Clear!</p>
                    <p className="text-sm">No issues reported by users.</p>
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-slate-50 dark:bg-slate-800/30 text-slate-600 dark:text-slate-400 text-sm">
                                <th className="px-6 py-3 font-semibold">Date</th>
                                <th className="px-6 py-3 font-semibold">Issue Type</th>
                                <th className="px-6 py-3 font-semibold">Description</th>
                                <th className="px-6 py-3 font-semibold">Context (Q/Exam)</th>
                                <th className="px-6 py-3 font-semibold text-right">Status</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
                            {reports.map((report) => (
                                <tr key={report.id} className="hover:bg-slate-50 dark:hover:bg-slate-700/30">
                                    <td className="px-6 py-4 text-sm text-slate-500 dark:text-slate-400">
                                        {new Date(report.createdAt).toLocaleDateString()}
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className={`px-2 py-1 rounded text-xs font-bold uppercase
                        ${report.issueType === 'wrong_answer' ? 'bg-red-100 dark:bg-red-950/30 text-red-700 dark:text-red-400' :
                                                 report.issueType === 'typo' ? 'bg-yellow-100 dark:bg-yellow-950/30 text-yellow-700 dark:text-yellow-400' : 'bg-blue-100 dark:bg-blue-950/30 text-blue-700 dark:text-blue-400'}
                      `}>
                                            {report.issueType.replace('_', ' ')}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-sm text-slate-800 dark:text-slate-200 max-w-xs truncate" title={report.description}>
                                        {report.description}
                                    </td>
                                    <td className="px-6 py-4 text-sm font-mono text-slate-500 dark:text-slate-400">
                                        <div>{report.examId}</div>
                                        <div className="text-xs">{report.questionId}</div>
                                    </td>
                                    <td className="px-6 py-4 text-right space-x-2">
                                        {report.status === 'open' ? (
                                            <>
                                                <button
                                                    onClick={() => handleResolveReport(report.id, 'resolved')}
                                                    className="px-3 py-1 bg-green-100 dark:bg-green-950/40 text-green-700 dark:text-green-400 rounded text-xs font-bold hover:bg-green-200 dark:hover:bg-green-900/40 transition-colors"
                                                >
                                                    Fix & Resolve
                                                </button>
                                                <button
                                                    onClick={() => handleResolveReport(report.id, 'dismissed')}
                                                    className="px-3 py-1 bg-slate-100 dark:bg-slate-900 text-slate-600 dark:text-slate-400 rounded text-xs font-bold hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors"
                                                >
                                                    Dismiss
                                                </button>
                                            </>
                                        ) : (
                                            <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${report.status === 'resolved' ? 'text-green-600 dark:text-green-400' : 'text-slate-400 dark:text-slate-500'}`}>
                                                {report.status}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminReports;
